import { EventMeta } from '../../../interfaces/meta.interface';

const copy: EventMeta = {
    title: 'Copy Item',
    default: {
        description: 'Copy Item',
        longDescription: 'A mailbox item was copied to another folder.',
        severity: 'info',
    },
};

export default copy;
